module.exports = __webpack_public_path__ + "static/media/destination.01d21ac9.png";